<template>
    <el-dialog class="common-dialog score-dialog"
               title="分数追回"
               :visible="visible"
               :before-close="closeDialog">
        <div>
            <p class="title">手工加分的作用：</p>
            <p class="desc">主要用于诊断结果与您网站的实际情况不符，如您认为诊断结果不够准确，此刻您可以选择手工加分为您的网站追回失分！</p>
            <span class="br"></span>
            <h3>本项{{itemData.title}}共被扣除<span class="error">{{itemData.score}}</span>分，确定手动追回？</h3>
            <el-button type="primary" size="full" @click="recoverScoreHandle()">确定追回分数</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { mapActions } from 'vuex';
    export default {
        props: ['visible', 'itemData'],
        data () {
            return {
            }
        },
        methods: {
            ...mapActions('check', [
                'recoverScore',
                'getList'
            ]),
            //关闭详情窗口
            closeDialog () {
                this.$emit('closeDialog');
            },
            //追回分数
            recoverScoreHandle () {
                this.recoverScore(this.itemData).then(message => {
                    this.$message({
                        message: message,
                        type: 'success'
                    });
                    this.closeDialog();
                }, error => {
                    this.$message.error(error);
                    this.closeDialog();
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .score-dialog {
        .title {
            font-size: 18px;
            margin: 0;
        }
        .desc {
            font-size: 18px;
            color: #949494;
        }
        .br {
            display: block;
            width: 100%;
            height: 0;
            margin: 35px 0;
            border-bottom: 1px solid #ccc;
        }
        h3 {
            font-weight: normal;
            font-size: 20px;
        }
        .el-button {
            height: 3rem;
            font-size: 1.3rem;
            margin-top: 2rem;
        }
    }
</style>
<style lang="scss">
    .score-dialog .el-dialog__body {
        padding-bottom: 5.17rem;
    }
</style>


// WEBPACK FOOTER //
// app/view/detail/ScoreDialog.vue